import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import MissionSection from './components/MissionSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-sand">
      <Navigation />
      <AboutHero />
      <MissionSection />
      <Footer />
    </div>
  );
}